//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      breadcrumbParams: 'ui/breadcrumbParams'
    }),
    routeName() {
      const lastMatchedRoute = this.$route.matched[this.$route.matched.length - 1]

      return this.$t(`routeNames.${lastMatchedRoute.path.slice(7)}`, this.breadcrumbParams)
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
